export default __webpack_public_path__ + "static/media/india.7622158f.svg";